/**
 * Angular `config.component.ts` submit toast when `YARDI_DATA_FETCH_RANGE_BY_DAYS` has errors (verbatim).
 *
 * Note: Angular applies `Validators.min(1)` + `Validators.max(365)` but the toast text says “1 to 366”.
 */

export const YARDI_FETCH_RANGE_DAYS_ERROR_MESSAGE =
  'Data Fetch Range By Days must be between 1 to 366'

const MIN_DAYS = 1
const MAX_DAYS = 365

/**
 * @returns `true` when valid; otherwise the Angular parity error string for `showError`.
 */
export function validateYardiDataFetchRangeByDays(
  raw: string,
): true | typeof YARDI_FETCH_RANGE_DAYS_ERROR_MESSAGE {
  const trimmed = raw.trim()
  if (!trimmed) return YARDI_FETCH_RANGE_DAYS_ERROR_MESSAGE
  const n = Number(trimmed)
  if (!Number.isFinite(n) || !Number.isInteger(n) || n < MIN_DAYS || n > MAX_DAYS) {
    return YARDI_FETCH_RANGE_DAYS_ERROR_MESSAGE
  }
  return true
}

